import { SelectionSystem } from '@aninix-inc/model'
import { useProject } from '@aninix/core'

export const useSelection = () => {
  const project = useProject()
  const selection = project.getSystemOrThrow(SelectionSystem)
  return selection
}
